export function isOrderOpen(status, brokerage) {
  if (brokerage === 'TRADIER' || brokerage === 'BACKTEST') {
    const openArr = [
      'open',
      'partially_filled',
      'pending',
      'calculated',
      'accepted_for_bidding',
      'held',
    ];
    if (openArr.includes(status)) return true;
    else return false;
  }
}
